import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { BaremetricsCalendar } from '../../../../../reusables/baremetrics-calendar/baremetrics-calendar.component';
import { PointStoreCategoriesService } from '../../services/point-store-categories.service';
import { PointStoreProductEditService } from '../../services/point-store-product-edit.service';
import { CompanySettingsService } from 'src/app/reusables/services/company-settings.service';
import { PointStoreProductService } from '../../services/point-store-product.service';

@Component({
  selector: 'cv-point-store-product-information',
  templateUrl: './point-store-product-information.component.html',
  styleUrls: ['./point-store-product-information.component.scss']
})
export class PointStoreProductInformationComponent implements OnInit {

  inputs = [{ "id": 1 }, { "id": 2 }];
  HasVariationPrices: boolean = false;
  HasProductVariations: boolean = false;
  isValid: boolean = true;
  pspes: any = null;
  pscs: any = null;
  visibleDropDown: string = "none"; //Other values are category and subcategory
  categoriesList = [];
  subCategoriesList = [];
  oldValue = null;
  invalidCharsRegex = new RegExp('^([^\\\\\\/!+<>?#&,%])*$');
  isPatternValid: boolean = true;

  @Input() next: (args: number) => void;
  @Input() cancel: () => void;

  constructor(
    private cvLocalizationService: CVLocalizationService,
    private pointStoreProductEditService: PointStoreProductEditService,
    private pointStoreCategoriesService: PointStoreCategoriesService,
    private companySettingsService: CompanySettingsService,
    private pointStoreProductService: PointStoreProductService,
  ) { }

  ngOnInit(): void {
    this.pspes = this.pointStoreProductEditService.pointStoreProductEditObj;
    this.pscs = this.pointStoreCategoriesService.data;
    this.companySettingsService.loadLoggedInCompanyValues();
    this.pointStoreCategoriesService.resetDataCategory.subscribe(cat =>  this.categoriesList = cat);
    this.pointStoreCategoriesService.resetDataSubCategory.subscribe(subCat =>  this.subCategoriesList = subCat);
  }

  addNewInputs() {
    this.pspes.modifiedPointStoreProduct.VariationsData[this.pspes.modifiedPointStoreProduct.VariationsData.length] = { "id": this.pspes.modifiedPointStoreProduct.VariationsData.length + 1 };
  }

  removeInputs(index) {
    this.pspes.modifiedPointStoreProduct.VariationsData.splice(index - 1, 1);
    for (let i = 0; i < this.pspes.modifiedPointStoreProduct.VariationsData.length; i++) {
      this.pspes.modifiedPointStoreProduct.VariationsData[i].id = i + 1;
    }
  }

  validateVariationInfo() {
    this.isValid = true;
    if (this.pspes.modifiedPointStoreProduct != undefined && this.pspes.modifiedPointStoreProduct.HasProductVariations) {
      if (this.pspes.modifiedPointStoreProduct.VariationName == undefined || this.pspes.modifiedPointStoreProduct.VariationName == "") {
        this.isValid = false;
      }
      this.pspes.modifiedPointStoreProduct.VariationsData.forEach((variation) => {
        if (variation.VariationName == undefined || variation.VariationName == ""
          || (!this.invalidCharsRegex.test(variation.VariationName) && !variation.VariationName.match(this.invalidCharsRegex))
          || (this.pspes.modifiedPointStoreProduct.HasVariationPrices && (variation.VariationPrice == undefined || variation.VariationPrice == "")))
          this.isValid = false;
      });
    }
    return this.isValid;
  }

  validateVariationName(value) {
    value.isPatternInvalid = true;

    const variationName = value?.VariationName?.trim();
    if (!this.invalidCharsRegex.test(variationName) && !variationName.match(this.invalidCharsRegex)) {
      value.isPatternInValid = true;
      this.isValid = false;
    } else {
      value.isPatternInvalid = false;
    }
  }

  convertToDate(date) {
    return new Date(date);
  }

  setProductStart(date: BaremetricsCalendar) {
    this.pspes.modifiedPointStoreProduct.ProductStart = date.current_date ? date.current_date.toDate() : null;
    this.pspes.modifiedPointStoreProduct.ProductStart_ForView = !date.current_date ? null : date.current_date.format(CVMomentDateFormat);
  }

  setProductEnd(date: BaremetricsCalendar) {
    this.pspes.modifiedPointStoreProduct.ProductEnd = date.current_date ? date.current_date.toDate() : null;
    this.pspes.modifiedPointStoreProduct.ProductEnd_ForView = !date.current_date ? null : date.current_date.format(CVMomentDateFormat);
  }

  getDollarFromCoinConversion() {
    if (this.pspes == null || this.pspes.modifiedPointStoreProduct == null || this.pspes.modifiedPointStoreProduct.Price == null) return "";

    let coinToCurrencyRatio = this.companySettingsService.getCompanyValueByFieldName("CoinToCurrencyValue");
    //var coinToCurrencyRatio = null;
    if (coinToCurrencyRatio == null) return "";
    return " ($" + ((this.pspes.modifiedPointStoreProduct.Price / coinToCurrencyRatio.NumericValue)).toFixed(2) + ")";
  };

  getCategoriesList() {
    if (this.categoriesList == null || this.categoriesList.length <= 0) {
      this.categoriesList = this.pscs.comboBoxCategoryMap.map(cat => cat.m_Item1);
    }
    return this.categoriesList;
  };

  getVariationsList() {
    if (this.categoriesList == null || this.categoriesList.length <= 0) {
      for (let i = 0; i < this.pscs.comboBoxCategoryMap.length; i++) {
        this.categoriesList.push(this.pscs.comboBoxCategoryMap[i].m_Item1);
      }
    }
    return this.categoriesList;
  };

  resetCategoriesList() {
    this.categoriesList = [];
  };

  resetSubCategoriesList() {
    this.subCategoriesList = null;
  };

  getSubCategoriesList(category) {
    if (category == null || category.length < 0) {
      return null;
    }
    if (this.subCategoriesList == null || (this.subCategoriesList.length == 0)) {
      this.subCategoriesList = [];
      const subCategories = this.pscs.comboBoxCategoryMap.find(cat => cat.m_Item1.toLowerCase() === category.toLowerCase());
      if(subCategories){
        this.subCategoriesList = subCategories.m_Item2;
      }
    }
    return this.subCategoriesList;
  };

  onCategorySelected(item) {
    this.pspes.modifiedPointStoreProduct.Category = item;
    this.resetSubCategoriesList();
    this.pspes.modifiedPointStoreProduct.SubCategory = "";
  };

  checkIntField(e, isPrice, variation = null) {
    if (e.keyCode == 8 || e.keyCode == 32) return false;
    if (!((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105))) {
      if (isPrice)
        this.pspes.modifiedPointStoreProduct.Price = this.pspes.modifiedPointStoreProduct.Price.substr(0, this.pspes.modifiedPointStoreProduct.Price.length - 1);
      else
        this.pspes.modifiedPointStoreProduct.Quantity = this.pspes.modifiedPointStoreProduct.Quantity.substr(0, this.pspes.modifiedPointStoreProduct.Quantity.length - 1);
      return false;
    }
    var quantity = parseInt(this.pspes.modifiedPointStoreProduct.Quantity);
    var price = parseInt(this.pspes.modifiedPointStoreProduct.Price);
    if (isPrice) {
      if (this.pspes.modifiedPointStoreProduct.Price && this.pspes.modifiedPointStoreProduct.Price.indexOf("-") != -1) {
        this.pspes.modifiedPointStoreProduct.Price = this.pspes.modifiedPointStoreProduct.Price.substr(0, this.pspes.modifiedPointStoreProduct.Price.length - 1);
        return false;
      }
      if (!angular.isNumber(price) || price < 0) {
        this.pspes.modifiedPointStoreProduct.Price = this.pspes.modifiedPointStoreProduct.Price.substr(0, this.pspes.modifiedPointStoreProduct.Price.length - 1);
        return false;
      }
    } else {
      if (this.pspes.modifiedPointStoreProduct.Quantity && this.pspes.modifiedPointStoreProduct.Quantity.indexOf("-") != -1) {
        this.pspes.modifiedPointStoreProduct.Quantity = this.pspes.modifiedPointStoreProduct.Quantity.substr(0, this.pspes.modifiedPointStoreProduct.Quantity.length - 1);
        return false;
      }
      if (!angular.isNumber(quantity) || quantity < 0) {
        this.pspes.modifiedPointStoreProduct.Quantity = this.pspes.modifiedPointStoreProduct.Quantity.substr(0, this.pspes.modifiedPointStoreProduct.Quantity.length - 1);
        return false;
      }
    }
  }

  checkIntFieldVariations(e, isPrice, variation) {
    let variationIndex;
    if (variation != null) {
      this.pspes.modifiedPointStoreProduct.VariationsData.forEach((v, index) => {
        if (variation.PointStoreProductVariationID != null) {
          if (v.PointStoreProductVariationID == variation.PointStoreProductVariationID)
            variationIndex = index;
        } else {
          if (v.id == variation.id)
            variationIndex = index;
        }
      });
    }
    if (e.keyCode == 8 || e.keyCode == 32) return false;
    if (!((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105))) {
      if (isPrice && this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationPrice != undefined)
        this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationPrice = this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationPrice.substr(0, this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationPrice.length - 1);
      else if (!isPrice && this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationQuantity != undefined)
        this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationQuantity = this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationQuantity.substr(0, this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationQuantity.length - 1);
      return false;
    }
    let quantity = parseInt(this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationQuantity);
    let price = parseInt(this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationPrice);
    if (isPrice) {
      if (this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationPrice && this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationPrice.indexOf("-") != -1) {
        this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationPrice = this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationPrice.substr(0, this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationPrice.length - 1);
        return false;
      }
      if (!angular.isNumber(price) || price < 0) {
        this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationPrice = this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationPrice.substr(0, this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationPrice.length - 1);
        return false;
      }
    } else {
      if (this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationQuantity && this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationQuantity.indexOf("-") != -1) {
        this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationQuantity = this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationQuantity.substr(0, this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationQuantity.length - 1);
        return false;
      }
      if (!angular.isNumber(quantity) || quantity < 0) {
        this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationQuantity = this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationQuantity.substr(0, this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationQuantity.length - 1);
        return false;
      }
    }
  }

  getOldValue(e, isPrice, variation = null) {
    if (e.keyCode == 8 || e.keyCode == 46) return;
    let variationIndex;
    if (variation != null) {
      variationIndex = this.getVariationIndex(variation);
    }
    if (variation != null) {
      if (isPrice) {
        this.oldValue = this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationPrice != null ? this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationPrice.toString() : "";
      } else
        this.oldValue = this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationQuantity != null ? this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationQuantity.toString() : "";
    } else {
      if (isPrice) {
        this.oldValue = this.pspes.modifiedPointStoreProduct.Price != null ? this.pspes.modifiedPointStoreProduct.Price.toString() : "";
      } else
        this.oldValue = this.pspes.modifiedPointStoreProduct.Quantity != null ? this.pspes.modifiedPointStoreProduct.Quantity.toString() : "";
    }

  }

  checkIntFieldValidation(e, isPrice, variation = null) {
    if (e.keyCode == 8 || e.keyCode == 46) return;
    let variationIndex;
    if (variation != null) {
      variationIndex = this.getVariationIndex(variation);
    }
    let validInput = this.inputFilter(e.key);

    if (this.oldValue < 0)
      validInput = false;

    if (this.oldValue != null) {
      if (!this.inputFilter(this.oldValue)) {
        this.oldValue = this.oldValue.replace(/\D/g, "");
      }
    }

    if (!validInput && variation != null) {
      if (isPrice && !this.inputFilter(this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationPrice)) {
        this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationPrice = this.oldValue;
      } else if (!this.inputFilter(this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationQuantity)) {
        this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationQuantity = this.oldValue;
      }
    } else if (!validInput && variation == null) {
      if (isPrice && !this.inputFilter(this.pspes.modifiedPointStoreProduct.Price)) {
        this.pspes.modifiedPointStoreProduct.Price = this.oldValue;
      } else if (!this.inputFilter(this.pspes.modifiedPointStoreProduct.Quantity)) {
        this.pspes.modifiedPointStoreProduct.Quantity = this.oldValue;
      }
    }
  }

  checkFieldOnBlur(e, isPrice, variation = null) {
    let variationIndex;
    let lastValidInput = !this.inputFilter(this.oldValue) ? this.oldValue?.replace(/\D/g, "") : this.oldValue;
    if (variation != null) {
      variationIndex = this.getVariationIndex(variation);
      if (isPrice) {
        if (!this.inputFilter(this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationPrice) && this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationPrice != null) {
          this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationPrice = lastValidInput;
        }
      } else {
        if (!this.inputFilter(this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationQuantity) && this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationQuantity != null) {
          this.pspes.modifiedPointStoreProduct.VariationsData[variationIndex].VariationQuantity = lastValidInput;
        }
      }
    } else {
      if (isPrice) {
        if (!this.inputFilter(this.pspes.modifiedPointStoreProduct.Price) && this.pspes.modifiedPointStoreProduct.Price != null) {
          this.pspes.modifiedPointStoreProduct.Price = lastValidInput;
        }
      } else {
        if (!this.inputFilter(this.pspes.modifiedPointStoreProduct.Quantity) && this.pspes.modifiedPointStoreProduct.Quantity != null) {
          this.pspes.modifiedPointStoreProduct.Quantity = lastValidInput;
        }
      }
    }
  }

  inputFilter(value) {
    return /^\d*$/.test(value);
  }

  getVariationIndex(variation) {
    let variationIndex;
    if (this.pspes.modifiedPointStoreProduct.VariationsData.length) {
      this.pspes.modifiedPointStoreProduct.VariationsData.forEach((v, index) => {
        if (variation.PointStoreProductVariationID != null) {
          if (v.PointStoreProductVariationID == variation.PointStoreProductVariationID)
            variationIndex = index;
        } else {
          if (v.id == variation.id)
            variationIndex = index;
        }
      });
    }
    return variationIndex;
  }

  isNumberKey(evt) {
    var charCode = (evt.which) ? evt.which : evt.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57))
      return false;
    return true;
  }

  enableMultipleVariation(event: any) {
    this.pspes.modifiedPointStoreProduct.HasProductVariations = event;
    const pointStoreProductID: number = this.pspes.modifiedPointStoreProduct.PointStoreProductID;
    const modeEditAndProdNoVariation: boolean = pointStoreProductID !== 0 && this.pspes.modifiedPointStoreProduct?.VariationsData?.length === 0;
    if (modeEditAndProdNoVariation) {
      const { VariationsData: initialObjVariation } = this.pointStoreProductService.getNewPointStoreProduct();
      this.pspes.modifiedPointStoreProduct.VariationsData = initialObjVariation;
      this.pspes.originalPointStoreProduct.VariationsData = initialObjVariation;
    }
  }

  disableDoubleLine(event, textarea): void {
    if(event && event.length > 0){
      if(event.includes('\n\n')){
        const newString = event.replace(/\n\s*\n/g, '\n');
        this.pspes.modifiedPointStoreProduct.Description = newString;
        textarea.value = newString;
      } else {
        //1. check (only spaces) different spaces, new line, different spaces (only spaces)
        const patternOne = /^\s*\n\s*$/;
        const matchedPatternOne = patternOne.test(event);
        if(matchedPatternOne){
          const newString = event.replace(patternOne, '');
          this.pspes.modifiedPointStoreProduct.Description = newString;
          textarea.value = newString;
        } else{

          //2. check new line, different spaces, new line
          const patternTwo = /\n\s+\n/;
          const matchedPatternTwo = patternTwo.test(event);
          if(matchedPatternTwo){
            const newString = event.replace(patternTwo, '\n');
            this.pspes.modifiedPointStoreProduct.Description = newString;
            textarea.value = newString;
          } else{

            //3. check (only spaces) different spaces, new line
            const patternThree = /^\s*\n/;
            const matchedPatternThree = patternThree.test(event);
            if(matchedPatternThree){
              const newString = event.replace(patternThree, '');
              this.pspes.modifiedPointStoreProduct.Description = newString;
              textarea.value = newString;
            }
          }
        }
      }
    }
  }

}
